<div class="fixed top-0 left-0 p-4 flex flex-col justify-center items-center space-y-8 h-screen w-screen z-[9999] bg-gradient-blue text-white text-shadow-lg">
    <img class="min-h-24 min-w-24" src="svg/logo-blanco.svg" alt="Logo Fincomercio">

    @if (consultor().qr) {
    <label for="desktop-message" class="max-w-2xl text-center text-lg font-medium">
        Para mejorar tu experiencia, por favor ingresa desde tu celular. Escanea el siguiente código QR con tu celular.
    </label>

    <hr class="w-2/4 border-white">

        <div class="qr-container shadow-2xl">
            <div class="qr-lights"></div>
            <img class="qr-image transform transition hover:scale-105" 
                 crossOrigin="anonymous" 
                 [src]="consultor()?.qr" 
                 alt="Código QR">
        </div>

        <label for="" class="text-center text-lg font-medium">
            <b>Asesor:</b> {{ consultor()?.name | titlecase }}
        </label>

        <label for="" class="text-center text-lg font-medium">
            OnBoarding Digital Gamificada
        </label>

        <label for="" class="text-center flex flex-col max-w-2xl text-lg font-medium">
            <p>
                Comparte:
            </p>
            <p class="bg-opacity-15 px-4 py-3 rounded-lg font-mono text-sm break-all shadow-inner transition hover:bg-opacity-20">
                {{ consultor()?.url }}
            </p>
        </label>
    } @else {
        <hr class="w-2/4 border-white">
        <div class="text-center max-w-2xl space-y-4">
            <div class="p-6 bg-opacity-10 rounded-xl shadow-lg">
                <p class="text-lg font-medium">
                    Comunícate con un asesor para que te comparta el enlace de acceso
                </p>
                <p class="text-sm opacity-80 mt-2">
                    No hemos podido cargar la información del asesor asignado
                </p>
            </div>
        </div>
    }
</div>